import { typography } from './typography';
import { breakpoints } from './breakpoints';
import { transition } from './transition';
import { borders } from './borders';
import { blur } from './blur';
import { radii } from './radius';
import { shadows } from './shadows';
import { zIndices } from './z-index';
import { sizes } from './sizes';
import { spacing } from './spacing';

export const foundations = {
  breakpoints,
  zIndices,
  radii,
  blur,
  sizes,
  shadows,
  space: spacing,
  borders,
  transition,
  ...typography,
};
